import { useSelector, useDispatch } from 'react-redux';
import { TableRow } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { setCardsParams, setSelected } from '@app/store/slices/cardsSlice';
import { icons } from '@shared/static/icons';
import Note from '@shared/ui/messages/Note';
import { useViewCardDialog } from '@utils/dialogs-hooks';
import { theme } from '@utils/libs/theme';
import { cardsColumns } from '@utils/tables/columns';
import {
  CardActionCell,
  CardDetailsCell,
  CardDetailsMobileCell,
  CardLimitCell,
  CardTypeCell,
  CheckboxCell,
  NoteCell,
} from '@widgets/tables/cells/cards';
import { StatusCreatedAtCell } from '@widgets/tables/cells/common';
import { MemberTeamCell } from '@widgets/tables/cells/transactions';
import { CustomTable, CustomTableMobile } from '@widgets/tables/main';

export default function CardsTable() {
  const dispatch = useDispatch();
  const {
    cards,
    params,
    count_total,
    count_filtered,
    selected,
    search,
    filtersCount,
    isLoading,
    isInitialized,
  } = useSelector((state) => state.cards);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { openViewCardDialog } = useViewCardDialog();

  const handleSetParams = (newParams) => {
    dispatch(setCardsParams(newParams));
  };

  const handleSetSelected = (newSelected) => {
    dispatch(setSelected(newSelected));
  };

  return isMobile ? (
    <CustomTableMobile
      params={params}
      setParams={handleSetParams}
      totalCount={count_total || 0}
      filteredCount={count_filtered || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      filtersCount={filtersCount}
      data={cards}
    >
      {cards?.map((row) => {
        const isItemSelected = selected.some((obj) => obj.id === row.id);
        return (
          <div
            key={row.id}
            className="tableMobile__list-item cardsMobile"
            onClick={() => openViewCardDialog(row.id)}
          >
            <div className="cardsMobile__item-bg">
              {icons[row.details?.bankName]}
            </div>
            <div className="cardsMobile__item">
              <CheckboxCell
                id={row.id}
                data={cards}
                isItemSelected={isItemSelected}
                selected={selected}
                setSelected={handleSetSelected}
                wrapInTableCell={false}
              />
              <CardDetailsMobileCell row={row} />
            </div>
            {row.note && (
              <Note singleLine noIcon type="info" content={row.note} />
            )}
          </div>
        );
      })}
    </CustomTableMobile>
  ) : (
    <CustomTable
      columns={cardsColumns}
      data={cards}
      params={params}
      setParams={handleSetParams}
      filteredCount={count_filtered || 0}
      totalCount={count_total || 0}
      selected={selected}
      setSelected={handleSetSelected}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      filtersCount={filtersCount}
    >
      {cards?.map((row) => {
        const isItemSelected = selected.some((obj) => obj.id === row.id);
        return (
          <TableRow
            tabIndex={-1}
            aria-checked={isItemSelected}
            selected={isItemSelected}
            key={row.id}
            onClick={(e) => {
              if (e.target.closest('[data-skip-row-click]')) return;
              openViewCardDialog(row.id);
            }}
          >
            <CheckboxCell
              id={row.id}
              data={cards}
              isItemSelected={isItemSelected}
              selected={selected}
              setSelected={handleSetSelected}
            />
            <CardDetailsCell row={row} />
            <StatusCreatedAtCell row={row} type="cards" />
            <CardTypeCell row={row} />
            <CardLimitCell row={row} />
            <MemberTeamCell row={row} />
            <NoteCell row={row} />
            <CardActionCell row={row} />
          </TableRow>
        );
      })}
    </CustomTable>
  );
}
